import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsCivilStatusMotherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared isMother scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusMotherPage.displayName =
  'Research Family Notifications CivilStatusMotherPage component';

export default ResearchFamilyNotificationsCivilStatusMotherPage;
